export const filterConditionGtIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M4 14.452L14.152 10 4 5.548 5.56 4l11.64 6-11.64 6z"/></svg>`,
  name: 'filter-condition-gt',
};
